import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-950 via-black to-blue-950 flex items-center overflow-hidden py-20 lg:py-0">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        {/* Smaller, less intrusive on mobile */}
        <div className="absolute top-10 left-5 w-20 h-20 md:w-32 md:h-32 border border-accent rounded-full"></div>
        <div className="absolute top-20 right-10 w-16 h-16 md:w-24 md:h-24 bg-accent/20 rounded-lg rotate-45"></div>
        <div className="absolute bottom-20 left-1/4 w-10 h-10 md:w-16 md:h-16 border-2 border-primary rounded-full"></div>
        <div className="absolute bottom-10 right-1/3 w-12 h-12 md:w-20 md:h-20 bg-primary/20 rounded-lg"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Content */}
          <div className="space-y-6 md:space-y-8 animate-fade-in order-2 lg:order-1">
            <div className="space-y-2 md:space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 md:w-12 h-1 bg-accent rounded-full"></div>
                <span className="text-accent font-medium tracking-wider uppercase text-xs sm:text-sm">
                  About Adrian
                </span>
              </div>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
                From Code to
                <span className="text-gradient-gold block">
                  Community
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-lg">
                A journey of transforming passion into purpose, building bridges between technology and humanity.
              </p>
            </div>

            <div className="space-y-4 md:space-y-6">
              <p className="text-base md:text-lg text-gray-200 leading-relaxed">
                Every line of code tells a story. Mine began with curiosity and evolved into a mission to empower others through technology. From my early days discovering programming to founding CodersHub and mentoring the next generation, this is the story of how individual growth becomes collective impact.
              </p>

              <div className="flex flex-wrap gap-2 md:gap-4">
                <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1.5 md:px-4 md:py-2">
                  <Icon name="Users" size={16} md:size={20} className="text-accent" />
                  <span className="text-white font-medium text-sm">500+ Mentees</span>
                </div>
                <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1.5 md:px-4 md:py-2">
                  <Icon name="Code" size={16} md:size={20} className="text-accent" />
                  <span className="text-white font-medium text-sm">50+ Projects</span>
                </div>
                <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1.5 md:px-4 md:py-2">
                  <Icon name="Award" size={16} md:size={20} className="text-accent" />
                  <span className="text-white font-medium text-sm">Community Leader</span>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-success rounded-full animate-pulse-gold"></div>
                <span className="text-gray-300 text-sm">Currently Available</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300 text-sm">
                <Icon name="MapPin" size={16} />
                <span>Buea, Cameroon</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative animate-slide-up order-1 lg:order-2 mb-12 lg:mb-0">
            <div className="relative">
              {/* Main Image */}
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-elevated">
                <Image
                  src="/me.png"
                   alt="Professional headshot of Ebesoh Adrian, Developer, Tutor, and Tech Innovator"
                  className="w-full h-[350px] md:h-[450px] lg:h-[550px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/60 via-transparent to-transparent"></div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 bg-accent text-secondary rounded-xl p-3 md:p-4 shadow-elevated animate-pulse-gold">
                <Icon name="Heart" size={20} md:size={24} />
              </div>
              
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-white rounded-xl p-3 md:p-4 shadow-elevated">
                <div className="flex items-center space-x-2">
                  <Icon name="MessageCircle" size={16} md:size={20} className="text-primary" />
                  <span className="text-secondary font-medium text-sm">Always Learning</span>
                </div>
              </div>

              {/* Background Decoration */}
              <div className="absolute -z-10 top-6 left-6 md:top-8 md:left-8 w-full h-full bg-gradient-to-br from-accent/20 to-primary/20 rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="flex flex-col items-center space-y-2 text-white/60">
          <span className="text-sm">Scroll to explore</span>
          <Icon name="ChevronDown" size={20} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;